import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from '../icons';

class ArtworkMobileShare extends React.Component{


	render(){
		return (<div className="mobile_share_holder">
			<button onClick={()=>this.props.closeSharer()} className="mobile_share_holder-close" ><Iconset.close /></button>
			<div className="mobile_share_holder-inner">
				<button className="mobile_share_holder_sharer" onClick={()=>this.props.shareOnFB()}>Share on Facebook</button>
			</div>
		</div>);
	}
}

export default ArtworkMobileShare;






// WEBPACK FOOTER //
// ./src/scripts/chapter3/artwork-mobile-share.js